const initialState = {
  reportsType: [
    { uniqId: 1, displayName: "Distance", value: "distance" },
    { uniqId: 2, displayName: "Mobile Tickets", value: "mobileTickets" },
    { uniqId: 2, displayName: "Pass Revenue", value: "pass" },
  ],
  selectedReportsType: "",
};
export default initialState;
